<template>
  <el-dialog
    :visible.sync="show"
    :close-on-click-modal="false"
    @close='close'
    :top="t"
    :width="w"
    class="notice_content_dia"
  >
    <div class="slot-dialog-header" slot="title">
      <span class="title">{{info.notification.title}}</span>
    </div>
    <div class="dialog-content">
      <vue-scroll :ops="disScrollOpt" ref>
        <div class="info_content">
          <div
            class="author"
          >{{info.notification.expediter}} &nbsp;&nbsp;&nbsp;&nbsp; {{info.notification.create_time | time}}</div>
          <div class="ql-container ql-snow">
            <div class='ql-editor edit_content' v-html="info.notification.content"></div>
          </div>
          <div class="files" v-if="info.document_list.length">
            <div class="file_header">
              <v-icon name="paperclip" scale="1.35"></v-icon>
              <span>附件（{{info.document_list.length}}个）</span>
            </div>
            <div class="files_list">
              <div class="file_item" v-for="file in info.document_list" :key="file.document_id">
                <span class="name">{{file.document_name}}</span>
                <a class="download" download :href="file.document_address">下载</a>
              </div>
            </div>
          </div>
        </div>
      </vue-scroll>
    </div>
    <!-- <div class="footer-btn" slot="footer">
      <el-button type="primary" v-if="info.notification.is_show_read" @click="iKnow">我知道了</el-button>
    </div> -->
  </el-dialog>
</template>

<script>
import ops from "@/assets/js/vuescrollOption";
import { knowNotice } from "@/api/notice/notice";
import "vue-awesome/icons/paperclip";

export default {
  name: "notice-deatil-dialog",
  components: {
    "v-icon": () => import("vue-awesome/components/Icon")
  },
  data() {
    return {
      disScrollOpt: ops(true)
    };
  },
  props: {
    ifShow: {
      type: Boolean,
      required: true
    },
    t: {
      type: String,
      default: "20vh"
    },
    w: {
      type: String,
      default: "830px"
    },
    info: {
      type: Object,
      required: true
    }
  },
  computed: {
    show: {
      get() {
        return this.ifShow;
      },
      set(bool) {
        this.$emit("hideDia", bool, false);
      }
    }
  },
  methods: {
    close() {
      this.$emit('know')
    },
    // iKnow() {
    //   if(this.info.notification.is_show_read) {
    //     knowNotice({ notification_id: this.info.notification.notification_id })
    //       .then(({ data: {status} }) => {
    //         if (Number(status) === 0) {
    //           this.$message.success("操作成功~");
    //           this.$emit('know')
    //         } else {
    //         }
    //       })
    //       .catch(err => {
    //         console.error(err);
    //       });
    //   }
    //   // this.show = false;
    // }
  }
};
</script>

<style lang="stylus">
.notice_content_dia {
  .el-dialog__header {
    font-size: 20px;
    text-align: center;
    background-color: #eee;
  }
  .info_content {
    .ql-container {
      border none 
      height auto
      font inherit 
    }
    .edit_content {
      // * {
      //   vertical-align initial
      //   padding unset 
      //   margin initial 
      //   border initial 
      // }
      // ol, ul {
      //   padding-left 40px
      // }
      // li {
      //   list-style initial
      // }
    }
  }
}
</style>

<style lang="stylus" scoped>
@import '~@/assets/css/variable';

.notice_content_dia {
  .title {
    // font-weight 600
  }

  .author {
    display: block;
    margin-bottom: 10px;
    border-bottom: 1px solid #ccc;
    font-weight: 600;
    padding-bottom: 5px;
    font-size: 16px;
  }

  .dialog-content {
    height: 390px;
    .info_content {
      display block 
      padding 0 15px 0 0
      word-break: break-all;
      word-wrap: break-word;
    }
    .files {
      display block 
      margin-top 20px 
    }

    .file_header {
      display: flex;
      align-items: center;
      padding-bottom: 8px;
      font-weight: 600;
      font-size: 16px;
      line-height: 1;

      svg {
        color: $color_suc;
        margin-right: 10px;
      }
    }

    .files_list {
      .file_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px solid #ccc;
        padding: 7px 25px;
        .download {
          color $color_suc;
        }
      }
    }
  }

  .create_info {
    text-align: right;
    margin-bottom: 20px;
  }

  svg {
    display: block;
  }
  
  .footer-btn{
    text-align : center;
  }
}
</style>
